import { useCallback, useMemo } from "react";

import { useApi } from "shared/services/api/useApi";
import { useQuery } from "react-query";

const useAllPages = () => {
    const { getDataAsync } = useApi();

    const getAllPagesApiCall = useCallback(async () => {
        const response = await getDataAsync("pages");
        
        const result = response.status === 204
            ? null
            : response.json();

        return result;
    }, [getDataAsync]);

    const pages = useQuery("pagesList", getAllPagesApiCall, {
        staleTime: Infinity,
        cacheTime: Infinity,
    });

    return useMemo(() => {
        return {
            pages,
        };
    }, [pages]);
};

export default useAllPages;
